import { z } from 'zod'

import type { MapItem } from 'src/shared/schemas/utils'

export const dateFlexibilityMap: Record<DateFlexibility, MapItem> = {
  immediate: { label: 'Immediate' },
  within_one_week: { label: 'Within One Week' },
  flexible: { label: 'Flexible' },
}

export const dateFlexibilitySchema = z.enum(Object.keys(dateFlexibilityMap) as [DateFlexibility, ...DateFlexibility[]])

export type DateFlexibility = 'immediate' | 'within_one_week' | 'flexible'
